/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import './index.scss'
import NavBar from '../../../components/navbar'

const tasks = [
  {
    taskDescription: 'Develop an survey form for indiegogo backers, to fill their order',
    team: 'me & product owner',
    workYouDid: [
      'Build a multi part react form application',
      'Validate the form in backend as well as front end',
      'Send the form to each backer(each with unique id) through mailchimp ',
      'Deploy the application to google cloud',
      'Fix bugs and update the application'
    ],
    tools: ['React', 'Node', 'PostgreSQL', 'Knex', 'Google Cloud', 'Mailchimp'],
    whatILearnt: [
      'Working on a full stack application',
      'Form validation on both client and server side',
      'Working with mailchimp API',
      'Deploying your app to google cloud'
    ],
    website: 'https://rens-survey-production.appspot.com/#/7721ff01-8b1e-4223-8080-237061c20633/'
  }
]

export const Survey = () => {
  return (
    <>
      <NavBar />
      <div className="survey">
        {tasks.map(task => (
          <div key={task} className="survey__work">
            <span>Task:</span>
            <p className="work__desc">{task.taskDescription}</p>
            <span>Team:</span>
            <p className="work__team">{task.team}</p>
            <span>What I did?</span>
            <ul className="work__you-did">
              {task.workYouDid.map(work => (
                <li key={work}> ==> {work}</li>
              ))}
            </ul>
            <span>What I learnt</span>
            <ul className="lessons">
              {task.whatILearnt.map(lesson => (
                <li key={lesson}>==> {lesson}</li>
              ))}
            </ul>
            <span>Tools Used</span>
            <ul className="tools__used">
              {task.tools.map(tool => (
                <li key={tool}>{tool}</li>
              ))}
            </ul>
            <span>Result:</span>{' '}
            <p className="result">
              <a href={task.website} target="__blank">
                Survey Form
              </a>
            </p>
          </div>
        ))}
      </div>
    </>
  )
}
export default Survey
